import { forwardRef, type SVGProps } from 'react';

export type PlusSquareProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const PlusSquare = forwardRef<SVGSVGElement, PlusSquareProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M16 11V21M21 16H11M16 4H8C5.79086 4 4 5.79086 4 8V24C4 26.2091 5.79086 28 8 28H24C26.2091 28 28 26.2091 28 24V8C28 5.79086 26.2091 4 24 4H16Z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));

PlusSquare.displayName = 'PlusSquare';
